(() => {
  const ownScript = document.currentScript || [...document.scripts].find((script) => /mwf-site-fixes\.js(?:\?|$)/.test(script.src));
  if (!ownScript?.src) return;
  if (window.__mwfSiteFixesLoaderV5) return;
  window.__mwfSiteFixesLoaderV5 = true;

  const assetUrl = (filename) => {
    const url = new URL(ownScript.src, location.href);
    url.pathname = url.pathname.replace(/mwf-site-fixes\.js$/, filename);
    url.search = `?mwf=${Date.now()}`;
    return url.toString();
  };
  const load = (filename, done) => {
    const script = document.createElement('script');
    script.src = assetUrl(filename);
    script.async = false;
    if (done) script.addEventListener('load', done, { once: true });
    document.head.appendChild(script);
  };
  load('mwf-site-fixes-base.js', () =>
    load('mwf-personaliser-polish.js', () =>
      load('mwf-personaliser-smart.js', () =>
        load('mwf-personaliser-enhancements.js', () =>
          load('mwf-personaliser-emergency-fix.js', () =>
            load('mwf-personaliser-final-layout.js', () =>
              load('mwf-personaliser-stability.js', () =>
                load('mwf-font00-bib-override.js')
              )
            )
          )
        )
      )
    )
  );
})();
